module.exports = __webpack_public_path__ + "static/img/id.b132f548.png";